import { Component, inject } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-update-available-snack',
    template: `
  <div>
    <p>An update is available. Would you like to update now?</p>
    <button type="button" mat-raised-button (click)="dismiss()">Dismiss</button>
    <button type="button" mat-raised-button (click)="update()" style="margin-left: 1em">Update Now</button>
  </div>
  `,
    styles: [],
    imports: [MatButton]
})
export class UpdateAvailableSnackComponent {
  matSnackBarRef = inject<MatSnackBarRef<UpdateAvailableSnackComponent>>(MatSnackBarRef);


  update() {
    this.matSnackBarRef.dismissWithAction();
  }

  dismiss() {
    this.matSnackBarRef.dismiss();
  }
}
